import styled from "styled-components";

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 0.4rem;
  position: relative;
  align-items: stretch;
  left: 0;
  /* justify-content: center; */
  margin-top: 20px;
  overflow: auto;
`;